import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AccessTokenResponse } from '../models/swagger/accessTokenResponse';
import { RefreshRequest } from '../models/swagger/refreshRequest';
import { LoginUserRequest } from "../models/swagger/loginUserRequest";
import { BooleanApiResponse } from '../models/swagger/booleanApiResponse';

@Injectable({
    providedIn: 'root'
})
export class AuthTokenService {

    private readonly USER_KEY = 'auth';
    private readonly ROLE_KEY = 'ad';

    private auth: AccessTokenResponse | undefined = undefined;
    private role: string | undefined = undefined;

    constructor(private http: HttpClient) {
        this.auth = localStorage.getItem(this.USER_KEY) != null ? JSON.parse(localStorage.getItem(this.USER_KEY)!) : undefined
        this.role = localStorage.getItem(this.ROLE_KEY) != null ? JSON.parse(localStorage.getItem(this.ROLE_KEY)!) : undefined
    }

    login(loginUserRequest: LoginUserRequest): Observable<AccessTokenResponse> {
        let endpoint: string = `${environment.base_url}/api/v1/auth/login`;
        return this.http.post<any>(endpoint, loginUserRequest);
    }

    logout(): Observable<any> {
        let endpoint: string = `${environment.base_url}/api/v1/auth/logout`;
        return this.http.post<any>(endpoint, null);
    }

    refreshToken(refreshRequest: RefreshRequest): Observable<AccessTokenResponse> {
        let endpoint: string = `${environment.base_url}/api/v1/auth/refresh`;
        return this.http.post<any>(endpoint, refreshRequest);
    }

    registerAuth(accessTokenResponse: AccessTokenResponse) {
        this.auth = accessTokenResponse
        localStorage.setItem(this.USER_KEY, JSON.stringify(accessTokenResponse));
    }

    registerRole(isAdmin: boolean) {
        this.role = isAdmin ? '2408' : '7913'
        localStorage.setItem(this.ROLE_KEY, JSON.stringify(this.role));
    }

    removeAuth() {
        this.auth = undefined;
        this.role = undefined;
        localStorage.removeItem(this.USER_KEY);
        localStorage.removeItem(this.ROLE_KEY);
    }

    getAuth(): AccessTokenResponse | undefined {
        return this.auth;
    }

    isAuthenticatedUser(): boolean {
        return this.auth != null
    }

    getAdminInfo(): Observable<BooleanApiResponse> {
        let endpoint: string = `${environment.base_url}/api/v1/insegne/role`;
        return this.http.get<any>(endpoint);
    }

    isAdmin(): boolean {
        return this.role == '2408';
    }
}
